import { render } from "./invites.vue?vue&type=template&id=00f12249&scoped=true"
import script from "./invites.vue?vue&type=script&lang=js"
export * from "./invites.vue?vue&type=script&lang=js"

import "./invites.vue?vue&type=style&index=0&id=00f12249&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f12249"]])

export default __exports__